import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import intl from 'react-intl-universal'
import dayjs from 'dayjs'
import { Collapse } from 'antd-mobile'

import ProductMenu from '../ProductMenu'
import Header from '../../../components/Header'
import BookingBox from '../../../components/BookingBox'

import { formatJSON } from '../../../utils'
import { getShoppingCart } from '../../../utils/storage/store'
import { calculateBookingTimes } from '../../../utils/bookRule'

import './index.less'
import { selectProductBookingRule, setOwnBookingRule } from '../../../store/reducers/hotel'




const SpaProduct = ({ list, callback, nextAction, merchantInfo, currentProduct, tagList = [], showHeader = true, children, openStateObj, isFinished = false }) => {
    const [step, setStep] = useState(1)
    const [bookingTimes, setBookingTimes] = useState(null)
    const [error, setError] = useState(null)
    const [pageFlag, setPageFlag] = useState(false)

    const { productRule } = useSelector(selectProductBookingRule) || {}

    const dispatch = useDispatch()
    useEffect(() => {

        // console.warn(list, '///===list===////', productRule)
        // calculateBookingTimes(merchantInfo)
        const { extendColumn1 } = merchantInfo
        const obj = formatJSON(extendColumn1) || {}
        let data = obj.bookingRule

        // 将预订规则转换为总毫秒数的辅助函数
        const getTotalMilliseconds = (rule) => {
            if (!rule) return 0
            const { endAdvanceDay = 0, endAdvanceHour = 0, endAdvanceMinute = 0 } = rule
            return endAdvanceDay * 24 * 60 * 60 * 1000 + 
                   endAdvanceHour * 60 * 60 * 1000 + 
                   endAdvanceMinute * 60 * 1000
        }

        // 如果 productRule 存在且时间更长，则使用 productRule
        if (productRule && data && getTotalMilliseconds(productRule) > getTotalMilliseconds(data)) {
            data = productRule
        }

        const bookingTimes = calculateBookingTimes({ extendColumn: JSON.stringify(data) })
        // console.log(bookingTimes)
        setBookingTimes(bookingTimes)
        dispatch(setOwnBookingRule(data))
    }, [merchantInfo, productRule])


    const { storeInfo = {}, storeId } = merchantInfo
    const products = getShoppingCart(storeId) || []

    const handleCallback = (num = 1, pageFlag = false) => {
        if (num === 3) {
            // callback && callback()
            setStep(1)
        } else {
            setStep(num)
        }
        setPageFlag(pageFlag)
    }

    // console.log(merchantInfo, '////====merchantInfo////')


    return (
        <div className="spa-menu-box">

            {
                step === 1 && (<>
                    {
                        showHeader && <Header title={storeInfo.shortName || storeInfo.name} callback={() => {
                            callback && callback()
                        }} />
                    }
                    <ProductMenu
                        list={list}
                        tagList={tagList}
                        merchantInfo={merchantInfo}
                        nextAction={() => handleCallback(2)}
                        currentProduct={currentProduct}
                        pageFlag={pageFlag}
                        readonly={!openStateObj?.openState}
                        isFinished={isFinished}
                    // switchView={true} 
                    >
                        {children}
                    </ProductMenu>
                </>)
            }
            {
                step === 2 && products.length > 0 && (
                    <BookingBox
                        callback={(num) => handleCallback(num, true)}
                        dates={bookingTimes?.dates}
                        from='spa'
                        merchantInfo={merchantInfo}
                        products={products}
                        productRule={productRule}
                    >
                        {/* <div className='bk-pd-box'>
                            <Collapse title={intl.get('aaa').d('项目')} defaultActiveKey={['1']}>
                                <Collapse.Panel key="1" title={intl.get('aaa').d('项目')}>
                                    <div className='bk-pd-list'>
                                        <div style={{ maxHeight: 200, overflowY: 'auto', backgroundColor: '#f5f5f5', paddingRight: 10, borderRadius: 6 }}>
                                            {products.map(item => (
                                                <div className='jm-flex bk-pd-item' key={item.productId}>
                                                    <div><img className='bk-pd-img' src={item.images} alt="" /></div>
                                                    <div className='jm-flex-item'>{item.productName} * {item.quantity}</div>
                                                    <div className='jm-price'><CurrencySymbol currency={item.currency} />{item.price * item.quantity}</div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className='bk-pd-total jm-flex'>
                                            <div className='jm-flex-item'>&nbsp;</div>
                                            <b className='jm-price'><CurrencySymbol currency={products[0].currency} />{products.reduce((acc, item) => acc + item.price * item.quantity, 0)}</b>
                                        </div>
                                    </div>
                                </Collapse.Panel>
                            </Collapse>

                        </div> */}
                    </BookingBox>)
            }
        </div>
    )
}

export default SpaProduct
